import { render, staticRenderFns } from "./TitleCreditsPortrait.vue?vue&type=template&id=c8e8dd16&scoped=true"
import script from "./TitleCreditsPortrait.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleCreditsPortrait.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleCreditsPortrait.vue?vue&type=style&index=0&id=c8e8dd16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e8dd16",
  null
  
)

export default component.exports